/*
 * HBSKN · Trade fair page engine (sections/hb-trade-fair.liquid).
 * Reads window.HB_FAIR injected by the section. No Liquid in this file.
 * Contract: handoffs/cosmoprof-asia-2026.md (GET /fair/slots, POST /fair/book, GET|POST /fair/booking, POST /fair/kit).
 * Phases on the section root (data-phase): pre | open | closed | post. Test override: ?hb_now=<ISO>.
 * Chinese layer: elements carry data-tf="<key>", the JSON is fetched only when 繁中/简中 is chosen.
 */
(function () {
  'use strict';

  var C = window.HB_FAIR;
  if (!C || !C.root) return;
  var root = document.getElementById(C.root);
  if (!root || root.hbtfReady) return;
  root.hbtfReady = true;

  var I18N = C.i18n || {};
  var TZ = C.tz || 'Asia/Hong_Kong';
  var HOME_TZ = C.homeTz || 'Europe/Rome';
  var TZL = C.tzLabel || 'HKT';
  var BASE_LANG = C.lang || 'en';
  var LANG = BASE_LANG;
  var ZH = null;
  var LS_LANG = 'hb_tf_lang';
  var SS_UTM = 'hb_tf_utm';
  var REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var LOCAL_TZ = (function () {
    try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { return ''; }
  })();
  var QS = new URLSearchParams(window.location.search);

  /* ---------------------------------------------------------------- helpers */

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  var ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return ESC[c]; }); }
  function enc(v) { return encodeURIComponent(v == null ? '' : v); }
  function fill(str, vars) {
    return String(str).replace(/\{(\w+)\}/g, function (m, k) { return vars && vars[k] != null ? vars[k] : m; });
  }
  function raw(key) {
    var d = ZH && ZH[LANG];
    if (d && d[key] != null) return d[key];
    return I18N[key] != null ? I18N[key] : key;
  }
  /* Plain text translation. */
  function T(key, vars) { return fill(raw(key), vars); }
  /* Escaped template, vars are trusted HTML snippets. */
  function TH(key, htmlVars) { return fill(esc(raw(key)), htmlVars); }

  function ls(key, val) {
    try {
      if (val === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, val);
    } catch (e) { /* private mode, blocked storage */ }
    return null;
  }

  var INTL = { en: 'en-GB', it: 'it-IT', de: 'de-DE', fr: 'fr-FR', es: 'es-ES', 'zh-Hant': 'zh-Hant-HK', 'zh-Hans': 'zh-Hans-CN' };
  function loc() { return INTL[LANG] || LANG; }
  var FMT = {};
  function fmt(ms, tz, opts) {
    var k = loc() + '|' + tz + '|' + JSON.stringify(opts);
    var f = FMT[k];
    if (f === undefined) {
      try { f = new Intl.DateTimeFormat(loc(), Object.assign({ timeZone: tz }, opts)); }
      catch (e) {
        try { f = new Intl.DateTimeFormat('en-GB', Object.assign({ timeZone: tz }, opts)); } catch (e2) { f = null; }
      }
      FMT[k] = f;
    }
    return f ? f.format(new Date(ms)) : new Date(ms).toISOString().slice(11, 16);
  }
  var HM = { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' };
  var HMD = { hour: '2-digit', minute: '2-digit', hourCycle: 'h23', day: 'numeric' };
  var DAY = { weekday: 'short', day: 'numeric', month: 'short' };
  function hm(ms, tz) { return fmt(ms, tz, HM); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function scrollToEl(el) {
    if (!el) return;
    try { el.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' }); } catch (e) { el.scrollIntoView(); }
  }
  function focusEl(el) {
    if (!el) return;
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }
  function track(name, data) {
    var d = Object.assign({ fair: C.fair }, data || {});
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, d);
      }
    } catch (e) { /* analytics never blocks the flow */ }
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, d)); } catch (e) { /* idem */ }
  }

  function api(method, path, body) {
    var ctl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 15000);
    var opts = { method: method, credentials: 'omit', signal: ctl ? ctl.signal : undefined };
    if (body) {
      opts.headers = { 'Content-Type': 'application/json' };
      opts.body = JSON.stringify(body);
    }
    return fetch(C.worker + path, opts).then(function (r) {
      return r.text().then(function (t) {
        var d = null;
        try { d = t ? JSON.parse(t) : null; } catch (e) { d = null; }
        clearTimeout(timer);
        return { status: r.status, ok: r.ok, data: d };
      });
    }, function (err) {
      clearTimeout(timer);
      throw err;
    });
  }

  var UTM = (function () {
    var u = { source: '', medium: '', campaign: '' };
    var found = false;
    ['source', 'medium', 'campaign'].forEach(function (k) {
      var v = QS.get('utm_' + k);
      if (v) { u[k] = v.slice(0, 120); found = true; }
    });
    try {
      if (found) window.sessionStorage.setItem(SS_UTM, JSON.stringify(u));
      else {
        var s = window.sessionStorage.getItem(SS_UTM);
        if (s) { var p = JSON.parse(s); ['source', 'medium', 'campaign'].forEach(function (k) { u[k] = String(p[k] || ''); }); }
      }
    } catch (e) { /* storage unavailable */ }
    return u;
  })();

  function postLang() {
    return ['en', 'it', 'zh-Hant', 'zh-Hans'].indexOf(LANG) > -1 ? LANG : 'en';
  }

  /* --------------------------------------------------------------- clock */

  var OFFSET = (function () {
    var p = QS.get('hb_now');
    if (!p) return 0;
    /* "+08:00" arrives as " 08:00" when the + is not encoded */
    var t = Date.parse(p.trim().replace(/ (\d{2}:?\d{2})$/, '+$1'));
    return isNaN(t) ? 0 : t - Date.now();
  })();
  function now() { return Date.now() + OFFSET; }

  var START = Date.parse(C.start);
  var END = Date.parse(C.end);
  var REG = Date.parse(C.regDeadline);
  function isoOffsetMin(iso) {
    var m = /([+-])(\d{2}):?(\d{2})$/.exec(iso || '');
    if (!m) return /Z$/.test(iso || '') ? 0 : null;
    return (m[1] === '-' ? -1 : 1) * (parseInt(m[2], 10) * 60 + parseInt(m[3], 10));
  }
  var FAIR_OFF = (function () { var o = isoOffsetMin(C.start); return o == null ? 480 : o; })();
  function minsOf(iso) {
    var m = /T(\d{2}):(\d{2})/.exec(iso || '');
    return m ? parseInt(m[1], 10) * 60 + parseInt(m[2], 10) : 0;
  }
  var OPEN_M = minsOf(C.start);
  var CLOSE_M = minsOf(C.end);
  function fairLocal(ms) { return new Date(ms + FAIR_OFF * 60000); }
  function ymdFair(ms) { return fairLocal(ms).toISOString().slice(0, 10); }

  function phaseAt(t) {
    if (isNaN(START) || isNaN(END)) return { p: 'pre', when: '' };
    if (t < START) return { p: 'pre', when: '' };
    if (t >= END) return { p: 'post', when: '' };
    var L = fairLocal(t);
    var mm = L.getUTCHours() * 60 + L.getUTCMinutes();
    if (mm >= OPEN_M && mm < CLOSE_M) return { p: 'open', when: '' };
    return { p: 'closed', when: mm < OPEN_M ? 'today' : 'tomorrow' };
  }

  var B = { el: $('[data-tf-book]') };
  var K = { el: $('[data-tf-kit]') };
  var PH = { p: root.getAttribute('data-phase') || 'pre', when: '' };

  function applyPhase(force) {
    var t = now();
    var ph = phaseAt(t);
    var changed = ph.p !== PH.p || ph.when !== PH.when;
    if (changed || force) {
      PH.p = ph.p;
      PH.when = ph.when;
      root.setAttribute('data-phase', PH.p);
      root.setAttribute('data-closed', PH.when);
      if (changed && B.onPhase) B.onPhase();
    }
    root.setAttribute('data-reg', !isNaN(REG) && t > REG ? 'closed' : 'open');
    renderCountdown(t);
  }

  var CD = {
    d: $('[data-tf-cd-d]'), h: $('[data-tf-cd-h]'), m: $('[data-tf-cd-m]'),
    sr: $('[data-tf-cd-sr]'), inl: $$('[data-tf-cdi]')
  };
  var cdKey = '';
  function renderCountdown(t) {
    var diff = Math.max(0, START - t);
    if (isNaN(diff)) return;
    var d = Math.floor(diff / 864e5); diff -= d * 864e5;
    var h = Math.floor(diff / 36e5); diff -= h * 36e5;
    var m = Math.floor(diff / 6e4);
    var key = d + ':' + h + ':' + m + ':' + LANG;
    if (key === cdKey) return;
    cdKey = key;
    if (CD.d) CD.d.textContent = pad(d);
    if (CD.h) CD.h.textContent = pad(h);
    if (CD.m) CD.m.textContent = pad(m);
    if (CD.sr) CD.sr.textContent = T('ui.cd_aria', { d: d, h: h, m: m });
    CD.inl.forEach(function (el) { el.textContent = T('ui.cd_inline', { d: d, h: pad(h), m: pad(m) }); });
  }

  /* -------------------------------------------- sticky offset under the theme header */

  var headVal = -1;
  var headQueued = false;
  function headerBottom() {
    var h = document.querySelector('.section-header');
    if (!h) return 0;
    var pos = window.getComputedStyle(h).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 0;
    return Math.max(0, Math.round(h.getBoundingClientRect().bottom));
  }
  function syncHead() {
    headQueued = false;
    var v = headerBottom();
    if (v !== headVal) {
      headVal = v;
      root.style.setProperty('--tf-head', v + 'px');
    }
  }
  function onScroll() {
    if (headQueued) return;
    headQueued = true;
    /* rAF does not fire while the page is not painting: setTimeout lands the final state anyway */
    window.requestAnimationFrame(syncHead);
    setTimeout(function () { if (headQueued) syncHead(); }, 120);
  }

  /* ----------------------------------------------------------- navigation */

  function goTo(name, tab) {
    var target = document.getElementById('tf-' + name);
    if (!target) return;
    if (tab && B.selectTab) B.selectTab(tab, { user: true });
    scrollToEl(target);
    var hs = target.querySelectorAll('h2');
    for (var i = 0; i < hs.length; i++) {
      if (hs[i].offsetParent !== null) { focusEl(hs[i]); break; }
    }
    try { window.history.replaceState(null, '', '#tf-' + name); } catch (e) { /* noop */ }
  }

  /* ------------------------------------------------------- Chinese layer */

  var ORIG = new WeakMap();
  var ORIG_ARIA = new WeakMap();
  var SW = $('[data-tf-lang]');

  function origText(el) {
    var d = document.createElement('div');
    d.innerHTML = ORIG.get(el);
    return d.textContent.trim();
  }
  function applyStatic() {
    var dict = ZH && ZH[LANG];
    var forMap = (ZH && ZH._for) || {};
    $$('[data-tf]').forEach(function (el) {
      if (!ORIG.has(el)) ORIG.set(el, el.innerHTML);
      var key = el.getAttribute('data-tf');
      var v = dict ? dict[key] : null;
      if (v != null && forMap[key] != null && origText(el) !== forMap[key]) v = null;
      if (v == null) {
        if (el.innerHTML !== ORIG.get(el)) el.innerHTML = ORIG.get(el);
        return;
      }
      var vars = null;
      var va = el.getAttribute('data-tf-vars');
      if (va) { try { vars = JSON.parse(va); } catch (e) { vars = null; } }
      v = fill(v, vars);
      if (/[<&]/.test(v)) el.innerHTML = v; else el.textContent = v;
    });
    $$('[data-tf-aria]').forEach(function (el) {
      if (!ORIG_ARIA.has(el)) ORIG_ARIA.set(el, el.getAttribute('aria-label') || '');
      var v = dict ? dict[el.getAttribute('data-tf-aria')] : null;
      el.setAttribute('aria-label', v != null ? v : ORIG_ARIA.get(el));
    });
  }
  function zhCode(l) { return l === 'zh-Hant' || l === 'zh-Hans' ? l : 'en'; }
  function loadZh() {
    if (ZH) return Promise.resolve(ZH);
    return fetch(C.zhUrl, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('zh ' + r.status); return r.json(); })
      .then(function (j) { ZH = j; return j; });
  }
  function syncSwitch() {
    if (!SW) return;
    var cur = zhCode(LANG);
    $$('[data-tf-setlang]', SW).forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-tf-setlang') === cur));
    });
  }
  function setLang(code, persist) {
    code = zhCode(code);
    function go() {
      LANG = code === 'en' ? BASE_LANG : code;
      root.setAttribute('lang', LANG);
      applyStatic();
      syncSwitch();
      rerender();
      if (persist) ls(LS_LANG, code);
    }
    if (code === 'en') { go(); return; }
    root.setAttribute('aria-busy', 'true');
    loadZh().then(go, function () { syncSwitch(); }).then(function () { root.removeAttribute('aria-busy'); });
  }
  function initLang() {
    if (!SW || !C.zhUrl) return;
    SW.hidden = false;
    SW.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tf-setlang]');
      if (b) setLang(b.getAttribute('data-tf-setlang'), true);
    });
    var pref = QS.get('hb_lang') || ls(LS_LANG);
    if (!pref) {
      var nl = String((navigator.languages && navigator.languages[0]) || navigator.language || '');
      if (/^zh\b/i.test(nl)) pref = /hant|tw|hk|mo/i.test(nl) ? 'zh-Hant' : 'zh-Hans';
    }
    if (pref === 'zh-Hant' || pref === 'zh-Hans') setLang(pref, !!QS.get('hb_lang'));
  }

  /* ----------------------------------------------------------- countries */

  var APAC = 'HK CN MO TW SG MY TH ID PH VN KR JP AU NZ IN AE SA QA KW'.split(' ');
  var ALL = ('AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ ' +
    'CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR ' +
    'GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG ' +
    'KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU ' +
    'MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW ' +
    'SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG ' +
    'US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW').split(' ');
  var EN_NAMES = {
    HK: 'Hong Kong', CN: 'China', MO: 'Macao', TW: 'Taiwan', SG: 'Singapore', MY: 'Malaysia', TH: 'Thailand',
    ID: 'Indonesia', PH: 'Philippines', VN: 'Vietnam', KR: 'South Korea', JP: 'Japan', AU: 'Australia',
    NZ: 'New Zealand', IN: 'India', AE: 'United Arab Emirates', SA: 'Saudi Arabia', QA: 'Qatar', KW: 'Kuwait',
    IT: 'Italy', GB: 'United Kingdom', US: 'United States', DE: 'Germany', FR: 'France', CH: 'Switzerland',
    ES: 'Spain', NL: 'Netherlands', BE: 'Belgium', AT: 'Austria', CA: 'Canada', XK: 'Kosovo'
  };
  var DN = null;
  function region(code) {
    try {
      if (!DN || DN.l !== loc()) DN = { l: loc(), f: new Intl.DisplayNames([loc()], { type: 'region', style: 'short' }) };
      var n = DN.f.of(code);
      if (n && n !== code) return n;
    } catch (e) { /* old browser: English fallback */ }
    return EN_NAMES[code] || code;
  }
  function fillCountries(sel) {
    var cur = sel.value;
    var opt = function (c) { return '<option value="' + c + '">' + esc(region(c)) + '</option>'; };
    var world = ALL.filter(function (c) { return APAC.indexOf(c) < 0; })
      .map(function (c) { return [c, region(c)]; })
      .sort(function (a, b) { return a[1].localeCompare(b[1], loc()); })
      .map(function (x) { return '<option value="' + x[0] + '">' + esc(x[1]) + '</option>'; })
      .join('');
    sel.innerHTML = '<option value="">' + esc(T('ui.select_ph')) + '</option>' +
      '<optgroup label="' + esc(T('ui.cg_apac')) + '">' + APAC.map(opt).join('') + '</optgroup>' +
      '<optgroup label="' + esc(T('ui.cg_world')) + '">' + world + '</optgroup>';
    if (cur) sel.value = cur;
  }

  /* --------------------------------------------------------------- forms */

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function fieldOf(el) { return el.closest('.hb-tf__field') || el.parentNode; }
  function errEl(el) { var id = el.getAttribute('data-tf-err'); return id ? document.getElementById(id) : null; }
  function setErr(el, msg) {
    el.setAttribute('aria-invalid', 'true');
    var f = fieldOf(el); if (f) f.classList.add('is-err');
    var p = errEl(el); if (p) { p.textContent = msg; p.hidden = false; }
  }
  function clrErr(el) {
    el.removeAttribute('aria-invalid');
    var f = fieldOf(el); if (f) f.classList.remove('is-err');
    var p = errEl(el); if (p) { p.textContent = ''; p.hidden = true; }
  }
  function errFor(el) {
    if (el.type === 'checkbox') {
      if (el.checked) return '';
      return el.name === 'privacy_ok' ? T('ui.err_privacy') : T('ui.err_required');
    }
    var v = String(el.value || '').trim();
    if (!v) return T('ui.err_required');
    if (el.type === 'email' && !EMAIL_RE.test(v)) return T('ui.err_email');
    return '';
  }
  function formErr(form, msg) {
    var box = $('[data-tf-formerr]', form);
    if (!box) return;
    box.textContent = msg;
    box.hidden = false;
  }
  function clearFormErr(form) {
    var box = $('[data-tf-formerr]', form);
    if (box) { box.hidden = true; box.textContent = ''; }
  }
  function validate(form) {
    var first = null;
    $$('[data-tf-req]', form).forEach(function (el) {
      var msg = errFor(el);
      if (msg) { setErr(el, msg); if (!first) first = el; } else clrErr(el);
    });
    if (first) {
      formErr(form, T('ui.err_check'));
      first.focus();
      return false;
    }
    return true;
  }
  function fieldErr(form, name) {
    var el = form.elements[name];
    if (!el || !el.nodeType || el.type === 'hidden') return false;
    var msg = name === 'email' ? T('ui.err_email') : name === 'privacy_ok' ? T('ui.err_privacy') : T('ui.err_required');
    setErr(el, msg);
    formErr(form, T('ui.err_check'));
    el.focus();
    return true;
  }
  function setBusy(form, on) {
    var b = $('[type="submit"]', form);
    form.setAttribute('aria-busy', String(on));
    if (!b) return;
    var lab = $('[data-tf-btnlabel]', b);
    b.disabled = on;
    if (!lab) return;
    if (on) { lab.setAttribute('data-orig', lab.textContent); lab.textContent = T('ui.sending'); }
    else if (lab.hasAttribute('data-orig')) { lab.textContent = lab.getAttribute('data-orig'); lab.removeAttribute('data-orig'); }
  }
  function wireLiveValidation(form) {
    var h = function (e) {
      var el = e.target;
      if (el && el.getAttribute && el.getAttribute('aria-invalid') === 'true' && !errFor(el)) clrErr(el);
    };
    form.addEventListener('input', h);
    form.addEventListener('change', h);
    var mt = form.elements.messenger_type;
    var box = $('[data-tf-msgid]', form);
    if (mt && box) {
      var sync = function () { box.hidden = !mt.value || mt.value === 'none'; };
      mt.addEventListener('change', sync);
      sync();
    }
  }
  function val(form, n) {
    var el = form.elements[n];
    return el && el.value != null ? String(el.value).trim() : '';
  }
  function checked(form, n) { var el = form.elements[n]; return !!(el && el.checked); }

  function btn(href, label, variant, external) {
    var attrs = external ? ' target="_blank" rel="noopener"' : '';
    var sr = external ? '<span class="hb-tf__sr"> (' + esc(T('ui.new_window')) + ')</span>' : '';
    return '<a class="hb-tf__btn' + (variant ? ' hb-tf__btn--' + variant : '') + '" href="' + esc(href) + '"' + attrs + '>' +
      '<span>' + esc(label) + '</span>' + sr + '<span class="hb-tf__arr" aria-hidden="true">→</span></a>';
  }

  /* ------------------------------------------------------------- booking */

  function whereText() {
    var d = ZH && ZH[LANG];
    var f = (ZH && ZH._for) || {};
    var hall = d && d['zh.hall'] && (!f['zh.hall'] || f['zh.hall'] === C.hall) ? d['zh.hall'] : C.hall;
    return (hall ? hall + ' · ' : '') + (C.booth ? T('ui.stand', { n: C.booth }) : T('ui.stand_tba'));
  }
  function localLine(ms, alsoHome) {
    if (!LOCAL_TZ || LOCAL_TZ === TZ) return '';
    var l = fmt(ms, LOCAL_TZ, HMD);
    if (l === fmt(ms, TZ, HMD)) return '';
    if (alsoHome && l === fmt(ms, HOME_TZ, HMD)) return '';
    var t = hm(ms, LOCAL_TZ);
    if (fmt(ms, LOCAL_TZ, { day: 'numeric' }) !== fmt(ms, TZ, { day: 'numeric' })) {
      t = fmt(ms, LOCAL_TZ, { weekday: 'short' }) + ' ' + t;
    }
    return T('ui.your_time', { time: t });
  }
  function tzDiffers() {
    if (!LOCAL_TZ || LOCAL_TZ === TZ) return false;
    var t = now();
    return fmt(t, LOCAL_TZ, HMD) !== fmt(t, TZ, HMD);
  }
  function normSlots(d) {
    var days = (d.days || []).map(function (day) {
      return {
        date: day.date,
        slots: (day.slots || []).map(function (s) {
          var st = Date.parse(s.start_utc);
          var en = Date.parse(s.end_utc);
          return { id: s.id, start: st, end: isNaN(en) ? st + 18e5 : en, label: s.label || '', available: !!s.available };
        }).filter(function (s) { return s.id && !isNaN(s.start); })
      };
    });
    return { days: days };
  }
  function load(kind, force) {
    if (B.data[kind] && !force) return Promise.resolve(B.data[kind]);
    if (B.pending[kind]) return B.pending[kind];
    B.err[kind] = false;
    var p = api('GET', '/fair/slots?fair=' + enc(C.fair) + '&kind=' + kind).then(function (r) {
      B.pending[kind] = null;
      if (!r.ok || !r.data || r.data.ok === false) throw new Error('slots ' + r.status);
      B.data[kind] = normSlots(r.data);
      return B.data[kind];
    }, function (e) {
      B.pending[kind] = null;
      throw e;
    }).catch(function (e) {
      B.err[kind] = true;
      throw e;
    });
    B.pending[kind] = p;
    return p;
  }
  function boothDay(i) {
    var d = B.data.booth;
    if (!d) return null;
    var want = isNaN(START) ? null : ymdFair(START + i * 864e5);
    for (var k = 0; k < d.days.length; k++) if (d.days[k].date === want) return d.days[k];
    return d.days[i] || null;
  }
  function allSlots(kind) {
    var d = B.data[kind];
    if (!d) return null;
    return d.days.reduce(function (a, day) { return a.concat(day.slots); }, []);
  }
  function findSlot(id) {
    var kinds = ['booth', 'video'];
    for (var i = 0; i < kinds.length; i++) {
      var list = allSlots(kinds[i]) || [];
      for (var j = 0; j < list.length; j++) if (list[j].id === id) return Object.assign({ kind: kinds[i] }, list[j]);
    }
    return null;
  }
  function dayLabel(day) {
    var first = day.slots[0];
    var ms = first ? first.start : Date.parse(day.date + 'T12:00:00Z');
    return fmt(ms, first ? TZ : 'UTC', DAY);
  }

  function renderTabCounts() {
    B.tabs.forEach(function (t) {
      var key = t.getAttribute('data-tf-tab');
      var out = $('[data-tf-tabn]', t);
      if (!out) return;
      var slots = null;
      if (key === 'video') slots = allSlots('video');
      else if (B.data.booth) { var day = boothDay(parseInt(key, 10)); slots = day ? day.slots : []; }
      if (!slots) { out.textContent = ''; return; }
      var n = slots.filter(function (s) { return s.available; }).length;
      out.textContent = n ? T('ui.n_free', { n: n }) : T('ui.full');
    });
  }
  function renderTz() {
    if (!B.tzline) return;
    var s = B.kind === 'video' ? T('ui.tz_note_video') : T('ui.tz_note_booth');
    if (tzDiffers()) s += ' ' + T('ui.tz_yours', { tz: LOCAL_TZ.replace(/_/g, ' ') });
    B.tzline.textContent = s;
  }
  function slotHtml(s) {
    var on = !!(B.pick && B.pick.id === s.id);
    var main = hm(s.start, TZ);
    var sub = B.kind === 'video' ? T('ui.italy_time', { time: hm(s.start, HOME_TZ) }) : TZL;
    var lc = localLine(s.start, B.kind === 'video');
    var aria = s.available ? '' : ' aria-label="' + esc(main + ' ' + TZL + ', ' + T('ui.slot_unavailable')) + '"';
    return '<li><button type="button" class="hb-tf__slot" data-tf-slot="' + esc(s.id) + '" aria-pressed="' + on + '"' +
      (s.available ? '' : ' disabled') + aria + '>' +
      '<span class="hb-tf__slot-t">' + esc(main) + '</span>' +
      '<span class="hb-tf__slot-s">' + esc(sub) + '</span>' +
      (lc ? '<span class="hb-tf__slot-l">' + esc(lc) + '</span>' : '') +
      '</button></li>';
  }
  function renderSlots() {
    if (!B.slots) return;
    var kind = B.kind;
    var data = B.data[kind];
    B.slots.setAttribute('aria-busy', 'false');
    if (B.vnote) B.vnote.hidden = kind !== 'video';
    if (!data && B.err[kind]) {
      B.vdays.hidden = true;
      B.slots.innerHTML = '<div class="hb-tf__slotmsg"><p>' + esc(T('ui.slots_error')) + '</p>' +
        '<button type="button" class="hb-tf__btn hb-tf__btn--o hb-tf__btn--sm" data-tf-retry><span>' + esc(T('ui.retry')) +
        '</span><span class="hb-tf__arr" aria-hidden="true">→</span></button></div>';
      renderTz();
      return;
    }
    if (!data) {
      B.vdays.hidden = true;
      B.slots.setAttribute('aria-busy', 'true');
      B.slots.innerHTML = '<p class="hb-tf__slotmsg hb-tf__slotmsg--load">' + esc(T('ui.loading')) + '</p>';
      renderTz();
      return;
    }
    var day = null;
    if (kind === 'video') {
      var days = data.days.filter(function (d) { return d.slots.length; });
      var has = days.some(function (d) { return d.date === B.vday; });
      if (!has) {
        var f = days.filter(function (d) { return d.slots.some(function (s) { return s.available; }); })[0] || days[0];
        B.vday = f ? f.date : '';
      }
      B.vdays.innerHTML = days.map(function (d) {
        var n = d.slots.filter(function (s) { return s.available; }).length;
        return '<button type="button" class="hb-tf__vday" data-tf-vday="' + esc(d.date) + '" aria-pressed="' + (d.date === B.vday) + '"' +
          (n ? '' : ' data-full') + '><span>' + esc(dayLabel(d)) + '</span><small>' +
          esc(n ? T('ui.n_free', { n: n }) : T('ui.full')) + '</small></button>';
      }).join('');
      B.vdays.hidden = !days.length;
      for (var i = 0; i < days.length; i++) if (days[i].date === B.vday) day = days[i];
    } else {
      B.vdays.hidden = true;
      day = boothDay(B.day);
    }
    var slots = day ? day.slots : [];
    B.slots.innerHTML = slots.length
      ? '<ul class="hb-tf__slotlist">' + slots.map(slotHtml).join('') + '</ul>'
      : '<p class="hb-tf__slotmsg">' + esc(T('ui.full')) + '</p>';
    renderTz();
  }
  function renderAll() { renderTabCounts(); renderSlots(); }

  function renderPick() {
    if (!B.sel) return;
    var s = B.pick;
    if (!s) { B.sel.innerHTML = ''; return; }
    var line = fmt(s.start, TZ, DAY) + ' · ' + hm(s.start, TZ) + '-' + hm(s.end, TZ) + ' ' + TZL;
    var sub = [];
    if (s.kind === 'video') sub.push(T('ui.video_label') + ' · ' + T('ui.italy_time', { time: hm(s.start, HOME_TZ) }));
    else sub.push(whereText());
    var lc = localLine(s.start, s.kind === 'video');
    if (lc) sub.push(lc);
    B.sel.innerHTML = '<div class="hb-tf__sel-txt"><p class="hb-tf__sel-k">' + esc(T('ui.sel_label')) + ' · ' + esc(T('ui.min30')) + '</p>' +
      '<p class="hb-tf__sel-v">' + esc(line) + '</p><p class="hb-tf__sel-s">' + sub.map(esc).join('<br>') + '</p></div>' +
      '<button type="button" class="hb-tf__link" data-tf-change>' + esc(T('ui.sel_change')) + '</button>';
  }
  function pickMsg(msg) {
    if (!B.pmsg) return;
    B.pmsg.textContent = msg || '';
    B.pmsg.hidden = !msg;
  }

  function tabFor(kind, ms) {
    if (kind === 'video') return 'video';
    for (var i = 0; i < B.dayTabs; i++) if (ymdFair(START + i * 864e5) === ymdFair(ms)) return String(i);
    return '0';
  }
  function defaultTab() {
    if (PH.p === 'post') return 'video';
    if (PH.p === 'open' || PH.p === 'closed') return tabFor('booth', now() + (PH.when === 'tomorrow' ? 864e5 : 0));
    return '0';
  }

  function choose(id) {
    var s = findSlot(id);
    if (!s || !s.available) return;
    B.pick = s;
    pickMsg('');
    renderSlots();
    if (B.mode === 'reschedule') {
      B.m.state = 'confirmMove';
      B.m.err = '';
      renderManage();
      scrollToEl(B.manage);
      focusEl($('[data-tf-mfocus]', B.manage));
      return;
    }
    renderPick();
    B.wrap.hidden = false;
    scrollToEl(B.sel);
    focusEl(B.sel);
    track('hb_fair_slot_selected', { kind: s.kind });
  }

  function parseManage(url) {
    if (!url) return null;
    try {
      var m = new URL(url, window.location.href).searchParams.get('manage') || '';
      var i = m.indexOf('.');
      return i > 0 ? { id: m.slice(0, i), t: m.slice(i + 1) } : null;
    } catch (e) { return null; }
  }
  function icsUrl(tok) {
    return C.worker + '/fair/ics?fair=' + enc(C.fair) + '&id=' + enc(tok.id) + '&t=' + enc(tok.t);
  }
  function gcalUrl(start, end, kind) {
    var z = function (ms) { return new Date(ms).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); };
    var where = kind === 'video' ? T('ui.video_label') : [C.venue, C.address, whereText()].filter(Boolean).join(', ');
    return 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + enc(C.calTitle || 'HBSKN') +
      '&dates=' + z(start) + '/' + z(end) + '&location=' + enc(where) + '&details=' + enc(C.pageUrl || '');
  }
  function whenHtml(start, end, kind) {
    var parts = [esc(fmt(start, TZ, DAY) + ' · ' + hm(start, TZ) + '-' + hm(end, TZ) + ' ' + TZL)];
    if (kind === 'video') parts.push(esc(T('ui.italy_time', { time: hm(start, HOME_TZ) + '-' + hm(end, HOME_TZ) })));
    var lc = localLine(start, kind === 'video');
    if (lc) parts.push(esc(lc));
    return parts.join('<br>');
  }
  function detailsHtml(o) {
    return '<dl class="hb-tf__okdl">' +
      (o.ref ? '<div><dt>' + esc(T('ui.ok_ref')) + '</dt><dd class="hb-tf__mono">' + esc(o.ref) + '</dd></div>' : '') +
      '<div><dt>' + esc(T('ui.ok_when')) + '</dt><dd>' + whenHtml(o.start, o.end, o.kind) + '</dd></div>' +
      '<div><dt>' + esc(T('ui.ok_where')) + '</dt><dd>' + esc(o.kind === 'video' ? T('ui.ok_video_where') : whereText()) + '</dd></div>' +
      '</dl>';
  }
  function calButtons(ics, gcal) {
    return (ics ? btn(ics, T('ui.ok_ics'), '', false) : '') + (gcal ? btn(gcal, T('ui.ok_gcal'), 'o', true) : '');
  }

  function renderOk() {
    var o = B.okData;
    if (!o || !B.ok) return;
    var res = o.res || {};
    var bk = res.booking || {};
    var kind = bk.kind || (o.slot && o.slot.kind) || 'booth';
    var start = Date.parse(bk.start_utc);
    if (isNaN(start)) start = o.slot ? o.slot.start : now();
    var end = Date.parse(bk.end_utc);
    if (isNaN(end)) end = o.slot ? o.slot.end : start + 18e5;
    var tok = parseManage(res.manage_url);
    var ics = res.ics_url || (tok ? icsUrl(tok) : '');
    var gcal = res.gcal_url || gcalUrl(start, end, kind);
    B.ok.innerHTML =
      '<p class="hb-tf__okbadge">' + esc(T('ui.ok_badge')) + '</p>' +
      '<h3 class="hb-tf__h3" data-tf-okh tabindex="-1">' + esc(kind === 'video' ? T('ui.ok_title_video') : T('ui.ok_title_booth')) + '</h3>' +
      detailsHtml({ ref: bk.ref || bk.id || '', start: start, end: end, kind: kind }) +
      (o.email ? '<p class="hb-tf__oknote">' + TH('ui.ok_email', { email: '<strong>' + esc(o.email) + '</strong>' }) + '</p>' : '') +
      '<div class="hb-tf__okact">' + calButtons(ics, gcal) + '</div>' +
      (res.manage_url ? '<p class="hb-tf__okmanage"><a class="hb-tf__link" href="' + esc(res.manage_url) + '">' + esc(T('ui.ok_manage')) +
        ' <span aria-hidden="true">→</span></a></p>' : '');
  }

  function onBookSubmit(e) {
    e.preventDefault();
    if (B.busy) return;
    var form = B.form;
    clearFormErr(form);
    if (!B.pick) {
      pickMsg(T('ui.pick_hint'));
      scrollToEl(B.picker);
      return;
    }
    if (!validate(form)) return;
    var mt = val(form, 'messenger_type') || 'none';
    var payload = {
      fair: C.fair,
      slot_id: B.pick.id,
      name: val(form, 'name'),
      company: val(form, 'company'),
      role: val(form, 'role'),
      email: val(form, 'email'),
      country: val(form, 'country'),
      business_type: val(form, 'business_type'),
      stores: val(form, 'stores'),
      interests: $$('input[name="interests"]:checked', form).map(function (i) { return i.value; }),
      message: val(form, 'message'),
      messenger_type: mt,
      messenger_id: mt === 'none' ? '' : val(form, 'messenger_id'),
      phone: val(form, 'phone'),
      lang: postLang(),
      marketing_consent: checked(form, 'marketing_consent'),
      privacy_ok: checked(form, 'privacy_ok'),
      utm: UTM,
      hp: val(form, 'hp')
    };
    B.busy = true;
    setBusy(form, true);
    var slot = B.pick;
    api('POST', '/fair/book', payload).then(function (r) {
      var code = r.data && r.data.error;
      if (r.ok && r.data && r.data.ok) {
        B.okData = { res: r.data, email: payload.email, slot: slot };
        B.picker.hidden = true;
        B.wrap.hidden = true;
        renderOk();
        B.ok.hidden = false;
        scrollToEl(B.ok);
        focusEl($('[data-tf-okh]', B.ok));
        track('hb_fair_meeting_booked', { kind: slot.kind, business_type: payload.business_type, country: payload.country });
        load(slot.kind, true).then(renderTabCounts, function () {});
        return;
      }
      if (r.status === 409 || code === 'slot_taken' || code === 'slot_id') { slotTaken(slot.kind); return; }
      if (r.status === 429) { formErr(form, T('ui.err_rate')); return; }
      if (r.status === 400 && code && fieldErr(form, code)) return;
      formErr(form, T('ui.err_generic'));
    }, function () {
      formErr(form, T('ui.err_network'));
    }).then(function () {
      B.busy = false;
      setBusy(form, false);
    });
  }
  function slotTaken(kind) {
    B.pick = null;
    renderPick();
    B.wrap.hidden = true;
    pickMsg(T('ui.err_slot_taken'));
    load(kind || B.kind, true).then(renderAll, renderAll);
    renderSlots();
    scrollToEl(B.picker);
    focusEl(B.pmsg);
  }

  /* -------------------------------------------------------- manage mode */

  function bkKind(bk) {
    if (bk.kind) return bk.kind;
    return /^v:/.test(bk.slot_id || '') ? 'video' : 'booth';
  }
  function bkStart(bk) {
    var t = Date.parse(bk.start_utc);
    if (!isNaN(t)) return t;
    var m = /^[bv]:(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})/.exec(bk.slot_id || '');
    if (!m) return NaN;
    if (bkKind(bk) === 'booth') {
      var o = FAIR_OFF;
      var sign = o < 0 ? '-' : '+';
      o = Math.abs(o);
      return Date.parse(m[1] + ':00' + sign + pad(Math.floor(o / 60)) + ':' + pad(o % 60));
    }
    /* video slot ids are in Italian time; November is CET (+01:00) */
    return Date.parse(m[1] + ':00+01:00');
  }
  function bkEnd(bk, start) {
    var t = Date.parse(bk.end_utc);
    return isNaN(t) ? start + 18e5 : t;
  }
  function mBtn(action, label, variant) {
    return '<button type="button" class="hb-tf__btn' + (variant ? ' hb-tf__btn--' + variant : '') + '" data-tf-m="' + action + '">' +
      '<span>' + esc(label) + '</span><span class="hb-tf__arr" aria-hidden="true">→</span></button>';
  }
  function renderManage() {
    var m = B.m;
    if (!m || !B.manage) return;
    var h = '<p class="hb-tf__kicker">' + esc(T('ui.m_title')) + '</p>';
    if (m.state === 'loading') {
      h += '<p class="hb-tf__mmsg">' + esc(T('ui.m_loading')) + '</p>';
    } else if (m.state === 'invalid') {
      h += '<p class="hb-tf__mmsg" data-tf-mfocus tabindex="-1">' + esc(T('ui.m_invalid')) + '</p>' +
        '<div class="hb-tf__okact">' + (C.email ? btn('mailto:' + C.email, T('ui.email_cta'), 'o', false) : '') +
        mBtn('again', T('ui.book_cta'), '') + '</div>';
    } else if (m.state === 'neterr') {
      h += '<p class="hb-tf__mmsg" data-tf-mfocus tabindex="-1">' + esc(T('ui.err_network')) + '</p>' +
        '<div class="hb-tf__okact">' + mBtn('retry', T('ui.retry'), 'o') + '</div>';
    } else {
      var bk = m.bk || {};
      var kind = bkKind(bk);
      var start = bkStart(bk);
      var end = bkEnd(bk, start);
      var cancelled = m.state === 'cancelled';
      h += '<h3 class="hb-tf__h3">' + esc(cancelled ? T('ui.m_cancelled_state') : (kind === 'video' ? T('ui.ok_title_video') : T('ui.ok_title_booth'))) + '</h3>';
      if (!isNaN(start)) h += detailsHtml({ ref: bk.ref || bk.id || m.id, start: start, end: end, kind: kind });
      if (m.err) h += '<p class="hb-tf__formerr" role="alert">' + esc(m.err) + '</p>';
      if (m.state === 'view' || m.state === 'moved') {
        if (m.state === 'moved') h += '<p class="hb-tf__mmsg" data-tf-mfocus tabindex="-1">' + esc(T('ui.m_moved')) + '</p>';
        h += '<div class="hb-tf__okact">' + mBtn('change', T('ui.m_change'), '') + mBtn('cancel', T('ui.m_cancel'), 'o') + '</div>';
        if (!isNaN(start)) h += '<div class="hb-tf__okact hb-tf__okact--sm">' + calButtons(icsUrl(m), gcalUrl(start, end, kind)) + '</div>';
      } else if (m.state === 'confirmCancel') {
        h += '<p class="hb-tf__mq" data-tf-mfocus tabindex="-1">' + esc(T('ui.m_cancel_q')) + '</p>' +
          '<div class="hb-tf__okact">' + mBtn('cancel-yes', T('ui.m_cancel_yes'), '') + mBtn('keep', T('ui.m_keep'), 'o') + '</div>';
      } else if (m.state === 'pick') {
        h += '<p class="hb-tf__mq" data-tf-mfocus tabindex="-1">' + esc(T('ui.m_pick')) + '</p>' +
          '<div class="hb-tf__okact">' + mBtn('keep', T('ui.m_keep'), 'o') + '</div>';
      } else if (m.state === 'confirmMove' && B.pick) {
        var p = B.pick;
        var when = fmt(p.start, TZ, DAY) + ' · ' + hm(p.start, TZ) + ' ' + TZL;
        h += '<p class="hb-tf__mq" data-tf-mfocus tabindex="-1">' + esc(T('ui.m_move_q', { when: when })) + '</p>' +
          '<div class="hb-tf__okact">' + mBtn('move-yes', T('ui.m_move_yes'), '') + mBtn('keep', T('ui.m_keep'), 'o') + '</div>';
      } else if (cancelled) {
        if (m.justCancelled) h += '<p class="hb-tf__mmsg" data-tf-mfocus tabindex="-1">' + esc(T('ui.m_cancelled')) + '</p>';
        h += '<div class="hb-tf__okact">' + mBtn('again', T('ui.m_book_again'), '') + '</div>';
      }
    }
    B.manage.innerHTML = h;
  }
  function manageFetch() {
    var m = B.m;
    m.state = 'loading';
    renderManage();
    api('GET', '/fair/booking?fair=' + enc(C.fair) + '&id=' + enc(m.id) + '&t=' + enc(m.t)).then(function (r) {
      var bk = r.ok && r.data && r.data.ok !== false ? (r.data.booking || r.data) : null;
      if (!bk || !(bk.start_utc || bk.slot_id)) m.state = 'invalid';
      else { m.bk = bk; m.state = bk.status === 'cancelled' ? 'cancelled' : 'view'; }
      renderManage();
    }, function () {
      m.state = 'neterr';
      renderManage();
    });
  }
  function initManage(param) {
    var i = param.indexOf('.');
    B.mode = 'manage';
    B.m = { id: i > 0 ? param.slice(0, i) : '', t: i > 0 ? param.slice(i + 1) : '', bk: null, state: 'loading', err: '' };
    B.picker.hidden = true;
    B.wrap.hidden = true;
    B.manage.hidden = false;
    setTimeout(function () { scrollToEl(B.manage); }, 80);
    if (!B.m.id || !B.m.t) { B.m.state = 'invalid'; renderManage(); return; }
    manageFetch();
  }
  function exitManage() {
    B.mode = 'book';
    B.m = null;
    B.pick = null;
    B.manage.hidden = true;
    B.manage.innerHTML = '';
    B.picker.hidden = false;
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('manage');
      window.history.replaceState(null, '', u.pathname + u.search + u.hash);
    } catch (e) { /* noop */ }
    B.selectTab(defaultTab());
    scrollToEl(B.picker);
  }
  function managePost(action, extra) {
    var m = B.m;
    var body = Object.assign({ fair: C.fair, id: m.id, t: m.t, action: action }, extra || {});
    return api('POST', '/fair/booking', body);
  }
  function onManageClick(e) {
    var b = e.target.closest('[data-tf-m]');
    if (!b || !B.m) return;
    var a = b.getAttribute('data-tf-m');
    var m = B.m;
    m.err = '';
    if (a === 'again') { exitManage(); return; }
    if (a === 'retry') { manageFetch(); return; }
    if (a === 'cancel') { m.state = 'confirmCancel'; renderManage(); focusEl($('[data-tf-mfocus]', B.manage)); return; }
    if (a === 'keep') {
      m.state = 'view';
      B.mode = 'manage';
      B.pick = null;
      B.picker.hidden = true;
      renderManage();
      return;
    }
    if (a === 'change') {
      m.state = 'pick';
      B.mode = 'reschedule';
      B.pick = null;
      B.picker.hidden = false;
      var bk = m.bk || {};
      var kind = bkKind(bk);
      var st = bkStart(bk);
      if (kind === 'video' && !isNaN(st)) B.vday = ymdFair(st);
      B.selectTab(isNaN(st) ? defaultTab() : tabFor(kind, st), { user: true });
      renderManage();
      scrollToEl(B.manage);
      focusEl($('[data-tf-mfocus]', B.manage));
      return;
    }
    if (a === 'cancel-yes' || a === 'move-yes') {
      var isMove = a === 'move-yes';
      var target = B.pick;
      if (b.disabled || (isMove && !target)) return;
      b.disabled = true;
      managePost(isMove ? 'reschedule' : 'cancel', isMove ? { slot_id: target.id } : null).then(function (r) {
        var code = r.data && r.data.error;
        if (r.ok && r.data && r.data.ok !== false) {
          if (isMove) {
            m.bk = r.data.booking || Object.assign({}, m.bk, {
              slot_id: target.id, kind: target.kind,
              start_utc: new Date(target.start).toISOString(), end_utc: new Date(target.end).toISOString()
            });
            m.state = 'moved';
            B.mode = 'manage';
            B.pick = null;
            B.picker.hidden = true;
            track('hb_fair_meeting_rescheduled', { kind: target.kind });
          } else {
            m.bk = r.data.booking || Object.assign({}, m.bk, { status: 'cancelled' });
            m.state = 'cancelled';
            m.justCancelled = true;
            track('hb_fair_meeting_cancelled', {});
          }
          B.data = {};
          renderManage();
          focusEl($('[data-tf-mfocus]', B.manage));
          load(B.kind, true).then(renderAll, renderAll);
          return;
        }
        if (isMove && (r.status === 409 || code === 'slot_taken')) {
          m.err = T('ui.err_slot_taken');
          m.state = 'pick';
          B.pick = null;
          load(B.kind, true).then(renderAll, renderAll);
        } else if (r.status === 429) {
          m.err = T('ui.err_rate');
        } else if (r.status === 401 || r.status === 403 || r.status === 404) {
          m.state = 'invalid';
        } else {
          m.err = T('ui.err_generic');
        }
        renderManage();
      }, function () {
        m.err = T('ui.err_network');
        renderManage();
      });
    }
  }

  function initBooking() {
    var el = B.el;
    Object.assign(B, {
      tabsWrap: $('[data-tf-tabs]', el),
      tabs: $$('[data-tf-tab]', el),
      panel: $('[data-tf-panel]', el),
      slots: $('[data-tf-slots]', el),
      vdays: $('[data-tf-vdays]', el),
      vnote: $('[data-tf-vnote]', el),
      tzline: $('[data-tf-tzline]', el),
      pmsg: $('[data-tf-pickmsg]', el),
      picker: $('[data-tf-picker]', el),
      wrap: $('[data-tf-formwrap]', el),
      sel: $('[data-tf-sel]', el),
      form: $('[data-tf-bookform]', el),
      ok: $('[data-tf-ok]', el),
      manage: $('[data-tf-manage]', el),
      kind: 'booth', day: 0, vday: '', data: {}, err: {}, pending: {},
      pick: null, busy: false, touched: false, mode: 'book', m: null, okData: null
    });
    if (!B.slots || !B.form || !B.tabsWrap) return;
    B.dayTabs = B.tabs.filter(function (t) { return t.getAttribute('data-tf-tab') !== 'video'; }).length;

    B.selectTab = function (key, opts) {
      opts = opts || {};
      if (opts.user) B.touched = true;
      B.kind = key === 'video' ? 'video' : 'booth';
      if (B.kind === 'booth') B.day = Math.max(0, parseInt(key, 10) || 0);
      B.tabs.forEach(function (t) {
        var on = t.getAttribute('data-tf-tab') === key;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        if (on && B.panel) B.panel.setAttribute('aria-labelledby', t.id);
        if (on && opts.focus) t.focus();
      });
      renderSlots();
      load(B.kind).then(renderAll, renderAll);
    };
    B.onPhase = function () {
      if (!B.touched && B.mode === 'book') B.selectTab(defaultTab());
    };

    B.tabs.forEach(function (t) {
      t.addEventListener('click', function () { B.selectTab(t.getAttribute('data-tf-tab'), { user: true }); });
    });
    B.tabsWrap.addEventListener('keydown', function (e) {
      var dir = { ArrowRight: 1, ArrowLeft: -1, Home: 'first', End: 'last' }[e.key];
      if (!dir) return;
      var vis = B.tabs.filter(function (t) { return t.offsetParent !== null; });
      var i = vis.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      var n = dir === 'first' ? 0 : dir === 'last' ? vis.length - 1 : (i + dir + vis.length) % vis.length;
      B.selectTab(vis[n].getAttribute('data-tf-tab'), { user: true, focus: true });
    });
    B.slots.addEventListener('click', function (e) {
      if (e.target.closest('[data-tf-retry]')) {
        B.err[B.kind] = false;
        renderSlots();
        load(B.kind, true).then(renderAll, renderAll);
        return;
      }
      var b = e.target.closest('[data-tf-slot]');
      if (b && !b.disabled) choose(b.getAttribute('data-tf-slot'));
    });
    B.vdays.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tf-vday]');
      if (!b) return;
      B.vday = b.getAttribute('data-tf-vday');
      renderSlots();
    });
    B.sel.addEventListener('click', function (e) {
      if (!e.target.closest('[data-tf-change]')) return;
      B.pick = null;
      renderPick();
      renderSlots();
      B.wrap.hidden = true;
      scrollToEl(B.picker);
      var first = $('.hb-tf__slot:not([disabled])', B.slots) || $('[aria-selected="true"]', B.tabsWrap);
      if (first) focusEl(first);
    });
    B.manage.addEventListener('click', onManageClick);
    B.form.addEventListener('submit', onBookSubmit);
    wireLiveValidation(B.form);

    var mp = QS.get('manage');
    if (mp) {
      initManage(mp);
      B.kind = 'booth';
      load('booth').then(renderAll, renderAll);
    } else {
      B.selectTab(defaultTab());
    }
    setTimeout(function () {
      load(B.kind === 'video' ? 'booth' : 'video').then(renderTabCounts, function () { /* counts stay empty */ });
    }, 1500);
  }

  /* ----------------------------------------------------------- trade kit */

  function renderKitOk() {
    if (!K.ok || !K.data) return;
    var files = K.data.files || [];
    K.ok.innerHTML = '<p class="hb-tf__okbadge">' + esc(T('ui.ok_badge')) + '</p>' +
      '<h3 class="hb-tf__h3" data-tf-kith tabindex="-1">' + esc(T('ui.kit_ok_title')) + '</h3>' +
      '<div class="hb-tf__okact">' + files.map(function (f, i) {
        return f && f.url ? btn(f.url, f.label || f.id || 'PDF', i ? 'o' : '', true) : '';
      }).join('') + '</div>' +
      '<p class="hb-tf__oknote">' + esc(T('ui.kit_ok_note')) + '</p>';
  }
  function initKit() {
    K.form = $('[data-tf-kitform]', K.el);
    K.ok = $('[data-tf-kitok]', K.el);
    if (!K.form) return;
    wireLiveValidation(K.form);
    K.form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (K.busy) return;
      clearFormErr(K.form);
      if (!validate(K.form)) return;
      var f = K.form;
      var payload = {
        fair: C.fair,
        name: val(f, 'name'),
        email: val(f, 'email'),
        company: val(f, 'company'),
        country: val(f, 'country'),
        business_type: val(f, 'business_type'),
        role: val(f, 'role'),
        lang: postLang(),
        marketing_consent: checked(f, 'marketing_consent'),
        privacy_ok: checked(f, 'privacy_ok'),
        utm: UTM,
        hp: val(f, 'hp')
      };
      K.busy = true;
      setBusy(f, true);
      api('POST', '/fair/kit', payload).then(function (r) {
        var code = r.data && r.data.error;
        if (r.ok && r.data && r.data.ok) {
          K.data = { files: r.data.files || [] };
          renderKitOk();
          f.hidden = true;
          K.ok.hidden = false;
          scrollToEl(K.ok);
          focusEl($('[data-tf-kith]', K.ok));
          track('hb_fair_kit_requested', { business_type: payload.business_type, country: payload.country });
          return;
        }
        if (r.status === 429) { formErr(f, T('ui.err_rate')); return; }
        if (r.status === 400 && code && fieldErr(f, code)) return;
        formErr(f, T('ui.err_generic'));
      }, function () {
        formErr(f, T('ui.err_network'));
      }).then(function () {
        K.busy = false;
        setBusy(f, false);
      });
    });
  }

  /* ------------------------------------------------------ global clicks */

  root.addEventListener('click', function (e) {
    var g = e.target.closest('[data-tf-goto]');
    if (g) {
      e.preventDefault();
      goTo(g.getAttribute('data-tf-goto'), g.getAttribute('data-tf-tab'));
      return;
    }
    var c = e.target.closest('[data-tf-copy]');
    if (!c) return;
    var id = c.getAttribute('data-tf-copy');
    var st = $('[data-tf-copystatus]', c.parentNode);
    var label = $('[data-tf-btnlabel]', c);
    var done = function (ok) {
      if (st) st.textContent = ok ? T('ui.copied') : T('ui.copy_fail', { id: id });
      if (label && ok) label.textContent = T('ui.copied');
      clearTimeout(c.hbT);
      c.hbT = setTimeout(function () {
        if (st) st.textContent = '';
        if (label) label.textContent = T('ui.copy_id');
      }, 2500);
    };
    var fallback = function () {
      try {
        var ta = document.createElement('textarea');
        ta.value = id;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        done(ok);
      } catch (er) { done(false); }
    };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(id).then(function () { done(true); }, fallback);
    else fallback();
  });

  /* ---------------------------------------------------------- re-render */

  function rerender() {
    cdKey = '';
    renderCountdown(now());
    $$('[data-tf-country]').forEach(fillCountries);
    if (B.slots) {
      renderTabCounts();
      renderSlots();
      renderPick();
      if (B.okData) renderOk();
      if (B.m) renderManage();
    }
    if (K.data) renderKitOk();
  }

  /* ----------------------------------------------------------------- map */

  // L'iframe di Google Maps nasce solo al click: niente cookie né IP verso Google senza un gesto.
  $$('[data-tf-map]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src = btn.getAttribute('data-tf-map');
      f.title = btn.getAttribute('data-tf-map-title') || '';
      f.loading = 'lazy';
      f.referrerPolicy = 'no-referrer-when-downgrade';
      f.setAttribute('allowfullscreen', '');
      btn.parentNode.replaceChild(f, btn);
    });
  });

  /* ---------------------------------------------------------------- boot */

  $$('[data-tf-country]').forEach(fillCountries);
  applyPhase(true);
  if (B.el) initBooking();
  if (K.el) initKit();
  initLang();
  syncHead();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  setTimeout(syncHead, 400);
  setInterval(function () { applyPhase(false); }, 1000);
  root.classList.add('is-ready');
})();
